import Vue from 'vue';

export const contractorDetailsService = {
  async retrieveContractor(referenceNumber) {
    return Vue.axios.get(`/contractors/${referenceNumber}`).then(response => response.data);
  },

  async retrieveContractorAttachments(referenceNumber) {
    return Vue.axios
      .get(`/contractors/${referenceNumber}/attachments`)
      .then(response => response.data);
  },

  async retrieveContractorAssignments(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/contractors/${referenceNumber}/assignments`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  },

  async saveContractor(contractorData, action) {
    delete contractorData.email;
    delete contractorData.name;
    let actionUrl = contractorData.reference_number
      ? `/contractors/${contractorData.reference_number}/?action=${action}`
      : `/contractors/create?action=${action}`;

    return Vue.axios
      .post(actionUrl, {
        ...contractorData
      })
      .then(response => response.data);
  },

  async retrieveContractorHistories(reference_number) {
    return Vue.axios
      .get(`/contractors/${reference_number}/history`)
      .then(response => response.data);
  },
  async retrieveContractorDepositSlips(reference_number) {
    return Vue.axios
      .get(`/contractors/${reference_number}/depositslips`)
      .then(response => response.data);
  }
};
